import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgbNavChangeEvent } from '@ng-bootstrap/ng-bootstrap';
import { AppService } from '../../services/app.service';

@Component({
    selector: 'app-portfolio',
    templateUrl: './portfolio.component.html'
})
export class PortfolioComponent implements OnInit {
    constructor(private app: AppService, private route: ActivatedRoute) { }

    activeTabId: number = 1;

    readonly tabs: { id: string, title: string }[] = [
        { id: 'programs', title: 'portfolio_programs' },
        { id: 'emrex', title: 'portfolio_emrex' }
    ];

    ngOnInit() {
        this.route.queryParams.subscribe(para => {
            const tabIx = this.tabs.findIndex(t => t.id == para.tab);

            if (tabIx !== -1) {
                this.activeTabId = tabIx + 1;
            }
        });
    }

    onTabChange(event: NgbNavChangeEvent) {
        const tab = this.tabs[event.nextId - 1].id;
        this.app.navigate(['/portfolio'], { queryParams: { tab } });
    }
}
